import * as Styles from "./styles";

export const Footer = ({ children }) => (
  <Styles.FooterButtons>
    {children && children}
  </Styles.FooterButtons>
);
